import RegisterWithDetailsStepRegisterForm from './form';

export default function RegisterWithDetailsStepRegister() {
  return <RegisterWithDetailsStepRegisterForm />;
}
